import { InputConfig } from "@cpj-ai/panel-npm-package";

export const inputConfigs: InputConfig[] = [
  {
    name: "newPassword1",
    previewSize: 12,
    inputProps: {
      type: "password",
      label: "Password:",
      placeholder: "Enter your password",
      showStrengthLevel: true,
    },
    rules: {
      required: "Password is required",
    },
  },
  {
    name: "newPassword2",
    previewSize: 12,
    inputProps: {
      type: "password",
      label: "Return New Password:",
      placeholder: "Re-enter your password",
      showStrengthLevel: false,
    },
    rules: {
      required: "Return password is required",
      validate: (value, formValues) => value === formValues.newPassword1 || "Passwords must match",
    },
  },
];
